import { render, staticRenderFns } from "./CarouselProgrammaticSlide.vue?vue&type=template&id=35945438&"
import script from "./CarouselProgrammaticSlide.vue?vue&type=script&lang=js&"
export * from "./CarouselProgrammaticSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports